import WashdayClientSingleton from './WashdayClientSingleton';

export const getLatestUpdates = async (limit?: number) => {
  try {
    return await WashdayClientSingleton.getInstance().updates.getLatestUpdates({ limit });
  } catch (e) {
    console.log('ERROR getLatestUpdates', e);
    throw e;
  }
};

export const markUpdatesAsSeen = async () => {
  try {
    return await WashdayClientSingleton.getInstance().updates.markUpdatesAsSeen();
  } catch (e) {
    console.log('ERROR markUpdatesAsSeen', e);
    throw e;
  }
};

